export default __webpack_public_path__ + "static/media/woocommerce-logo.dd629241.png";